module.exports = "<p>\r\n  includedcompanies works!\r\n</p>\r\n"